import React from 'react';
import { DatePicker, Button, Radio, Input, message, Checkbox, ConfigProvider } from 'antd';
import Loading from '../../components/loading/loading';
import DocumentTitle from 'react-document-title';
import API from '../../../api/api';
import moment from 'moment';
import UEditor from "../../components/ueditor/ueditor";
import './add.less';
import zhCN from 'antd/es/locale/zh_CN';
var uploader = require('../../../thirdTool/alioss/upload.js');
const { RangePicker } = DatePicker;

message.config({
    top: 200,
    duration: 2,
    maxCount: 3,
});

class CouponsAdd extends React.Component {

    constructor(props) {
        super(props)
    }

    state = {
        pageData: {
            id: '',
            couponName: '',
            couponSimpleName: '',
            couponImg: '',
            activateCouponImg: '',
            couponUseExplain: '',
            activateCouponUseExplain: '',
            couponTag: '',
            multiRange: '',
            timeType: 0, // 0 绝对时间，1 相对时间
            canTogetherUse: 0,
            couponStartTime: '', // s
            couponEndTime: '', // s
            receiveExpireTime: '',
            couponNum: '',
            validateMode: '30',
            amount: '',
            comRange: [
                {
                    functionType: 40,
                    functionName: '美团外卖',
                    useCircleId: '',
                    useType: 0, // 0城市 1圈子
                    relationType: 0, // 0否 1 是
                    isSelect: false,
                },
                {
                    functionType: 41,
                    functionName: '美团打车',
                    useCircleId: '',
                    useType: 0, // 0城市 1圈子
                    relationType: 0, // 0否 1 是
                    isSelect: false,
                },
                {
                    functionType: 13,
                    functionName: '票友电影',
                    useCircleId: '',
                    useType: 0, // 0城市 1圈子
                    relationType: 0, // 0否 1 是
                    isSelect: false,
                },
                {
                    functionType: 14,
                    functionName: '机票',
                    useCircleId: '',
                    useType: 0, // 0城市 1圈子
                    relationType: 0, // 0否 1 是
                    isSelect: false,
                },
                {
                    functionType: 15,
                    functionName: '火车票',
                    useCircleId: '',
                    useType: 0, // 0城市 1圈子
                    relationType: 0, // 0否 1 是
                    isSelect: false,
                },
            ]
        },
        isLoading: true,
        hasClicked: false,
        defaultMoment: [],
        defaultValue: [],
        errorArr: new Map([
            ['amount', true],
            ['couponName', true],
            ['couponSimpleName', true],
            ['couponImg', true],
            ['activateCouponImg', true],
            ['couponUseExplain', true],
            ['activateCouponUseExplain', true],
            ['couponTag', true],
            ['multiRange', true],
            ['couponStartTime', true],
            ['receiveExpireTime', true],
            ['couponNum', true],
        ]),
    }

    async getPictureInfo(url) { // 获取图片信息
        let result = await API.syncPic({ url: url });
        if (!result) return;
        if (result) {
            let picObj = {
                picture: url,
                width: result.ImageWidth.value,
                height: result.ImageHeight.value
            }
            return picObj;
        }
        else {
            message.error(result.msg);
        }
    };

    async getCouponDetail(id, callback) { // 获取券详情
        let result = await API.couponDetail({ id });
        if (!result) return;
        if (result.status == 1) {
            let pageData = result.data, defaultMoment = [];
            if (pageData.couponStartTime) {
                defaultMoment.push(moment(pageData.couponStartTime * 1000), moment(pageData.couponEndTime * 1000));
            }
            pageData.comRange = JSON.parse(pageData.comRange);
            pageData.canTogetherUse = pageData.canTogetherUse || 0;
            pageData.couponImg = JSON.parse(pageData.couponImg)
            pageData.activateCouponImg = JSON.parse(pageData.activateCouponImg)
            pageData.amount = pageData.amount / 100;
            let defaultValue = pageData.comRange.map((item) => {
                if (item.isSelect) return item.functionName;
            }).filter(Boolean);
            this.setState({ defaultMoment, pageData, defaultValue, isLoading: false }, () => {
                callback();
                let { pageData } = this.state;
                let errorArr = new Map([
                    ['amount', false],
                    ['couponName', false],
                    ['couponSimpleName', false],
                    ['couponImg', false],
                    ['activateCouponImg', false],
                    ['couponUseExplain', false],
                    ['activateCouponUseExplain', false],
                    ['couponTag', false],
                    ['multiRange', false],
                    ['couponStartTime', false],
                    ['receiveExpireTime', false],
                    ['couponNum', false],
                ])
                this.setState({ errorArr })
                if (pageData.couponImg) {
                    let chooseCouponImgDiv = document.getElementById('chooseCouponImg');
                    chooseCouponImgDiv.style.backgroundImage = 'url(' + pageData.couponImg.picture + ')';
                }
                if (pageData.couponImg) {
                    let chooseActivateCouponImgDiv = document.getElementById('chooseActivateCouponImg');
                    chooseActivateCouponImgDiv.style.backgroundImage = 'url(' + pageData.activateCouponImg.picture + ')';
                }
                //编辑器类型处理
                if (pageData.couponUseExplain) {
                    let ueditor = window.UE.getEditor('couponUseExplain');
                    ueditor.ready(function () {
                        console.log('couponUseExplain', ueditor.setContent);
                        ueditor.setContent(pageData.couponUseExplain);
                    });
                }
                if (pageData.activateCouponUseExplain) {
                    let ueditor2 = window.UE.getEditor('activateCouponUseExplain');
                    ueditor2.ready(function () {
                        ueditor2.setContent(pageData.activateCouponUseExplain);
                    });
                }
            })
            return;
        }
        message.error(result.msg);
    };

    async edit(params) { // 发布活动
        console.log('params', params)
        let result = await API.couponEdit(params);
        if (!result) return;
        if (result.status == 1) {
            message.success(result.msg);
            this.goBack();
            return;
        }
        message.error(result.msg);
    };

    componentDidMount() {
        let { pageData } = this.state;
        if (this.getQueryString('id') && this.getQueryString('id') != 'null') {
            pageData.id = this.getQueryString('id');
            this.setState({ pageData }, () => {
                this.getCouponDetail(pageData.id, () => {
                    this.initUpload();
                });
            })
            return;
        }
        this.setState({ isLoading: false }, () => {
            this.initUpload();
        })
    }

    initUpload() { //初始化视频上传
        let self = this;
        let buttonList = [
            {
                buttonID: 'chooseCouponImg',
                picType: 'couponImg',
                extensions: 'jpg,png,bmp,jpeg',
            },
            {
                buttonID: 'chooseActivateCouponImg',
                picType: 'activateCouponImg',
                extensions: 'jpg,png,bmp,jpeg',
            },
        ]
        buttonList.map((item) => {
            setTimeout(() => {
                let buttonDiv = document.getElementById(item.buttonID);
                if (buttonDiv) {
                    uploader({
                        serverUrl: window.location.origin + '/promotion/oss/policy',
                        upload_button: item.buttonID,
                        multi: false,
                        extensions: 'jpg,png,bmp,jpeg',
                        added: function () {
                        },
                        success: function (file_url, file) {
                            self.getPictureInfo(file_url).then(obj => {
                                let { pageData, errorArr } = self.state;
                                if (item.picType == 'couponImg') {
                                    errorArr.set('couponImg', false);
                                    pageData.couponImg = obj
                                }
                                if (item.picType == 'activateCouponImg') {
                                    pageData.activateCouponImg = obj
                                    errorArr.set('activateCouponImg', false);
                                }
                                self.setState({ pageData, errorArr })
                                buttonDiv.style.backgroundImage = 'url(' + obj.picture + ')';
                            });
                        },
                        error: function (msg) {
                            message.error(msg)
                        }
                    })
                }
            }, 100)
        })
    }

    handleUEditorChange = (type, content) => { //编辑器
        let { errorArr, pageData } = this.state;
        switch (type) {
            case 'couponUseExplain':
                pageData.couponUseExplain = content.trim();
                this.setState({ pageData });
                errorArr.set('couponUseExplain', content.trim() == '' ? true : false);
                break;
            case 'activateCouponUseExplain':
                pageData.activateCouponUseExplain = content.trim();
                this.setState({ pageData });
                errorArr.set('activateCouponUseExplain', content.trim() == '' ? true : false);
                break;
        }
        this.setState({ errorArr });
    }

    timeTypeChange(timeType, e) {
        console.log('timeType', timeType, e.target.value)
        let { pageData } = this.state;
        pageData[timeType] = e.target.value;
        this.setState({ pageData });
    }

    useTypeChange(useType, index, e) {
        console.log('useType', useType, index, e.target.value)
        let { pageData } = this.state;
        pageData.comRange[index][useType] = e.target.value;
        this.setState({ pageData });
    }

    getQueryString(name) {//解析url
        const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        const urlObj = window.location;
        var r = urlObj.href.indexOf('#') > -1 ? urlObj.hash.split("?")[1].match(reg) : urlObj.search.substr(1).match(reg);
        if (r != null) return unescape(r[2]); return null;
    }


    dateChange(dates) { //时间范围变化函数
        let { errorArr, pageData } = this.state;
        if (dates.length == 0) {
            errorArr.set('couponStartTime', true)
            errorArr.set('couponEndTime', true)
            pageData.couponStartTime = 0
            pageData.couponEndTime = 0
            this.setState({ pageData, errorArr })
            return;
        }

        if (dates[0].valueOf()) {
            errorArr.set('couponStartTime', false)
            pageData.couponStartTime = dates[0].valueOf() / 1000;
        }
        if (dates[1].valueOf()) {
            errorArr.set('couponEndTime', false)
            pageData.couponEndTime = dates[1].valueOf() / 1000;
        }
        this.setState({ pageData, errorArr })
    }

    saveCoupon() {
        this.setState({ hasClicked: true }, () => {
            let pageData = this.state.pageData;
            let errorArr = this.state.errorArr;

            // 通用范围
            let comRangeTure = pageData.comRange.filter((item) => {
                return item.isSelect
            })
            if (comRangeTure.length == 0) {
                errorArr.set('comRange', true);
                this.setState({ errorArr });
                return
            }

            // 使用条件 指定圈子 公众圈ID
            let useCircleIdHave = true;
            pageData.comRange.map((item, index) => {
                if (item.useType == 1 && !item.useCircleId) {
                    useCircleIdHave = false
                    errorArr.set(`useCircleId${index}`, true);
                }
            })
            if (!useCircleIdHave) {
                this.setState({ errorArr });
                return
            }

            console.log('saveCoupon', comRangeTure)
            if (document.querySelectorAll('.formItemError')[0]) {
                let firstError = document.querySelectorAll('.formItemError')[0];
                window.scrollTo(0, firstError.offsetTop - 100);
                return;
            }
            pageData.amount = pageData.amount * 100
            pageData.comRange = JSON.stringify(pageData.comRange);
            pageData.couponImg = JSON.stringify(pageData.couponImg);
            pageData.activateCouponImg = JSON.stringify(pageData.activateCouponImg);
            console.log('pageData', pageData)
            this.edit(pageData)
        })

    }

    inputItemChange(type, e, index) {
        let value = e.target.value;
        let { errorArr, pageData } = this.state;
        console.log('value', value, type)
        switch (type) {
            case 'couponName':
                errorArr.set('couponName', value.trim() == '' ? true : false);
                pageData.couponName = value;
                this.setState({ pageData })
                break;
            case 'couponSimpleName':
                errorArr.set('couponSimpleName', value.trim() == '' ? true : false);
                pageData.couponSimpleName = value;
                this.setState({ pageData })
                break;
            case 'couponTag':
                errorArr.set('couponTag', value.trim() == '' ? true : false);
                pageData.couponTag = value;
                this.setState({ pageData })
                break;
            case 'multiRange':
                errorArr.set('multiRange', value.trim() == '' ? true : false);
                pageData.multiRange = value;
                this.setState({ pageData })
                break;
            case 'receiveExpireTime':
                errorArr.set('receiveExpireTime', value.trim() == '' ? true : false);
                pageData.receiveExpireTime = value;
                this.setState({ pageData })
                break;
            case 'couponNum':
                errorArr.set('couponNum', value.trim() == '' ? true : false);
                pageData.couponNum = value;
                this.setState({ pageData })
                break;
            case 'amount':
                errorArr.set('amount', value.trim() == '' ? true : false);
                pageData.amount = value;
                this.setState({ pageData })
                break;
            case 'useCircleId':
                errorArr.set(`useCircleId${index}`, value.trim() == '' ? true : false);
                pageData.comRange[index].useCircleId = value;
                this.setState({ objectIds: value })
                break;
        }
        this.setState({ errorArr })
    }

    inputItemChangeChild(type, index, e) {
        let value = e.target.value;
        let { errorArr, pageData } = this.state;
        errorArr.set(`${type}${index}`, value.trim() == '' ? true : false);
        pageData.comRange[index][type] = value;
        this.setState({ objectIds: value })
        this.setState({ errorArr })
    }

    goBack() {
        this.props.history.go(-2)
    }

    generalScopeChange(checkedValues) {
        console.log('checked = ', checkedValues);
        let { pageData, errorArr } = this.state;
        if (checkedValues.length == 0) {
            errorArr.set('comRange', true);
            pageData.comRange.map((i, index) => {
                pageData.comRange[index].isSelect = false;
            })
        } else {
            errorArr.set('comRange', false);
            pageData.comRange.map((i, index) => {
                pageData.comRange[index].isSelect = false;
                checkedValues.map((item) => {
                    if (item == i.functionName) {
                        pageData.comRange[index].isSelect = true;
                    }
                })
            })

        }
        console.log('pageData', pageData)
        this.setState({ pageData, errorArr })
    }

    conditionChange(type, index, e) {
        console.log('conditionChange=', type, index, e.target.checked);
        let { pageData } = this.state;
        pageData.comRange[index][type] = e.target.checked;
        this.setState({ pageData })
    }

    render() {
        const {
            hasClicked,
            errorArr,
            defaultMoment,
            pageData,
            defaultValue,
            isLoading,
        } = this.state;
        if (isLoading) return <Loading />;
        const {
            id,
            couponName,
            couponSimpleName,
            couponUseExplain,
            activateCouponUseExplain,
            couponTag,
            multiRange,
            timeType, // 0 绝对时间，1 相对时间
            canTogetherUse,
            receiveExpireTime,
            couponNum,
            comRange,
            amount,
        } = pageData;
        console.log('couponUseExplain', couponUseExplain)
        let plainOptions = comRange.map((item) => {
            return item.functionName
        })
        return (
            <DocumentTitle title="优惠券">
                <ConfigProvider locale={zhCN}>
                    <div className="couponsAdd">
                        <Button onClick={this.goBack.bind(this)}>返回</Button>
                        <div className="inputItem">
                            <span className="inputTitle">券名称</span>
                            <Input className="inputBlock" value={couponName} placeholder="请输入券名称" onChange={this.inputItemChange.bind(this, 'couponName')}></Input>
                            {hasClicked && errorArr.get('couponName') && <span className="formItemError">请输入券名称</span>}
                        </div>
                        <div className="inputItem">
                            <span className="inputTitle">券简称</span>
                            <Input className="inputBlock" value={couponSimpleName} placeholder="请输入券简称" onChange={this.inputItemChange.bind(this, 'couponSimpleName')}></Input>
                            {hasClicked && errorArr.get('couponSimpleName') && <span className="formItemError">请输入券简称</span>}
                        </div>
                        <div className="inputItem">
                            <span className="inputTitle">券标签</span>
                            <Input className="inputBlock" value={couponTag} placeholder="请输入券标签" onChange={this.inputItemChange.bind(this, 'couponTag')}></Input>
                            {hasClicked && errorArr.get('couponTag') && <span className="formItemError">请输入券标签</span>}
                        </div>
                        <div className="inputItem">
                            <span className="inputTitle">券金额(元)</span>
                            <Input className="inputBlock" value={amount} placeholder="请输入券金额" onChange={this.inputItemChange.bind(this, 'amount')}></Input>
                            {hasClicked && errorArr.get('amount') && <span className="formItemError">请输入券金额</span>}
                        </div>
                        <div className="inputItem">
                            <span className="inputTitle">激活前券图片</span>
                            <div id="chooseCouponImg" className="chooseCouponImg"></div>
                            {hasClicked && errorArr.get('couponImg') && <span className="formItemError">请上传激活前券图片</span>}
                        </div>
                        <div className="inputItem align-flex-start">
                            <span className="inputTitle">激活前使用说明</span>
                            <div className="editorPane">
                                {
                                    <UEditor id='couponUseExplain' content={couponUseExplain} onChange={this.handleUEditorChange.bind(this, 'couponUseExplain')} />
                                }
                                {hasClicked && errorArr.get('couponUseExplain') && <span className="editorItemError">请填写激活前使用说明</span>}
                            </div>
                        </div>
                        <div className="inputItem">
                            <span className="inputTitle">激活后券图片</span>
                            <div id="chooseActivateCouponImg" className="chooseActivateCouponImg"></div>
                            {hasClicked && errorArr.get('activateCouponImg') && <span className="formItemError">请上传激活后券图片</span>}
                        </div>
                        <div className="inputItem align-flex-start">
                            <span className="inputTitle">激活后使用说明</span>
                            <div className="editorPane">
                                <UEditor id='activateCouponUseExplain' content={activateCouponUseExplain} onChange={this.handleUEditorChange.bind(this, 'activateCouponUseExplain')} />
                                {hasClicked && errorArr.get('activateCouponUseExplain') && <span className="editorItemError">请填写激活后使用说明</span>}
                            </div>
                        </div>
                        <div className="inputItem">
                            <span className="inputTitle">使用范围</span>
                            <Input className="inputBlock multiRange" value={multiRange} placeholder="在卡包列表及选择券的列表显示" onChange={this.inputItemChange.bind(this, 'multiRange')}></Input>
                            {hasClicked && errorArr.get('multiRange') && <span className="formItemError">请输入使用范围</span>}
                        </div>
                        <div className="inputItem">
                            <span className="inputTitle">有效期</span>
                            <Radio.Group onChange={this.timeTypeChange.bind(this, 'timeType')} value={timeType}>
                                <Radio value={0}>绝对时间</Radio>
                                <Radio value={1}>相对时间</Radio>
                            </Radio.Group>
                        </div>
                        <div className="inputItem">
                            <span className="inputTitle">可叠加使用</span>
                            <Radio.Group onChange={this.timeTypeChange.bind(this, 'canTogetherUse')} value={canTogetherUse}>
                                <Radio value={1}>开启</Radio>
                                <Radio value={0}>关闭</Radio>
                            </Radio.Group>
                        </div>
                        {
                            timeType == 0 &&
                            <div className="inputItem">
                                <span className="inputTitle">开始时间-结束时间</span>
                                <RangePicker className="datePicker" defaultValue={defaultMoment} width={400} format="YYYY-MM-DD HH:mm:ss" showTime={{ defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('11:59:59', 'HH:mm:ss')] }} onChange={this.dateChange.bind(this)} />
                                {hasClicked && (errorArr.get('couponStartTime') || errorArr.get('couponEndTime')) && <span className="formItemError">请选择券使用时间</span>}
                            </div>
                        }
                        {
                            timeType == 1 &&
                            <div className="inputItem">
                                <span className="inputTitle">过期时间(天)</span>
                                <Input className="inputBlock" value={receiveExpireTime} placeholder="请输入整数天" onChange={this.inputItemChange.bind(this, 'receiveExpireTime')}></Input>
                                {hasClicked && errorArr.get('receiveExpireTime') && <span className="formItemError">请输入过期时间</span>}
                            </div>
                        }
                        <div className="inputItem">
                            <span className="inputTitle">券数量</span>
                            <Input className="inputBlock" value={couponNum} placeholder="请输入整数" onChange={this.inputItemChange.bind(this, 'couponNum')}></Input>
                            {hasClicked && errorArr.get('couponNum') && <span className="formItemError">请输入券数量</span>}
                        </div>
                        <div className="inputItem">
                            <span className="inputTitle">通用范围</span>
                            {
                                ((id && defaultValue.length > 0) || !id) &&
                                <Checkbox.Group options={plainOptions} defaultValue={defaultValue} onChange={this.generalScopeChange.bind(this)} />
                            }
                            {hasClicked && errorArr.get('comRange') && <span className="formItemError">请选择通用范围</span>}
                        </div>
                        {
                            comRange && comRange.length > 0 &&
                            <div className="inputItem">
                                <span className="inputTitle">使用条件</span>
                            </div>
                        }
                        {
                            comRange && comRange.length > 0 &&
                            comRange.map((item, index) => {
                                if (item.isSelect) {
                                    return (
                                        <div className='conditionModel' key={index}>
                                            <div className="inputItem">
                                                <span className="inputTitle">{item.functionName}使用条件</span>
                                                <Radio.Group onChange={this.useTypeChange.bind(this, 'useType', index)} value={item.useType}>
                                                    <Radio value={0}>城市圈子</Radio>
                                                    <Radio value={1}>指定圈子</Radio>
                                                </Radio.Group>
                                                {
                                                    item.useType == 1 &&
                                                    <div>
                                                        <span className='useCircleId'>公众圈ID</span>
                                                        <Input className="inputBlock" value={item.useCircleId} placeholder="请输入" onChange={this.inputItemChangeChild.bind(this, 'useCircleId', index)}></Input>
                                                        {hasClicked && errorArr.get(`useCircleId${index}`) && <span className="formItemError">请输入公众圈ID</span>}
                                                    </div>
                                                }
                                            </div>
                                            <div className="relationType">
                                                <Checkbox checked={item.relationType} onChange={this.conditionChange.bind(this, 'relationType', index)}>业务关联</Checkbox>
                                            </div>
                                        </div>
                                    )
                                }
                            })
                        }
                        <Button onClick={this.saveCoupon.bind(this)}>立即创建</Button>
                    </div>
                </ConfigProvider>
            </DocumentTitle>
        )
    }
}
export default CouponsAdd;
